<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tJzBZl/tc-custom/9781480432949.jpg?1733111463479" alt="This image is the cover for the book Nature of Alexander"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nature of Alexander
      </h1>
      <p class="bookDescription body article font2">
        <b>An “intriguing and invaluable” biography of Alexander the Great by the novelist whose fiction redefined Ancient Greece (<i>The New York Times</i>).</b><br/><br/> Acclaimed writer Mary Renault is widely known for her provocative historical novels of Alexander the Great and his lovers. But she also authored this nonfiction classic, a fresh, illuminating look at a man whose legend has remained larger than life for more than two thousand years.<br/>  <br/> From his dysfunctional family dynamics to his molding under Aristotle, from his shocking rise to power at age twenty to the staggering violence of his military campaigns, Renault is clear-eyed about Alexander’s accomplishments and his flaws. Infectious in its enthusiasm, this is a penetrating study of an unrivaled conqueror, enduring icon, and fascinating man.<br/>  <br/> Hailed as both “a splendid achievement in nonfiction” (<i>The Plain Dealer</i>) and “the perfect companion to her Alexander novels” (<i>The Wall Street Journal</i>), Renault’s engrossing and accessible biography stands alone in the pantheon of Alexander the Great literature.<br/><br/><i>This ebook features an illustrated biography of Mary Renault including rare images of the author.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Renault
      </h2>
      
      <p class="authorDescription body article">Born in London as Eileen Mary Challans in 1905 and educated at the University of Oxford, Mary Renault trained as a nurse at Oxford's Radcliffe Infirmary. It was there that she met her lifelong partner, fellow nurse Julie Mullard. After completing her training, Renault wrote her first novel,&#160;<I>Purposes of Love</I>, in 1937. In 1948, after her novel&#160;<I>Return to Night</I>&#160;won an MGM prize worth $150,000, she and Mullard immigrated to South Africa. There, Renault wrote the historical novels that would define her career. In 2006, Renault was the subject of a BBC 4 documentary, and her books, many of which remain in print on both sides of the Atlantic, are often sought after for radio and dramatic interpretation. In 2010,&#160;<I>Fire From Heaven&#160;</I>was shortlisted for the 1970 Lost Booker prize.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6a56e95a